import { SectionHeading } from '@/components/Layout/SectionHeading';

import { CompanyPaysTable } from '../components/CompanyPaysTable';
import { SelectPaycycleCurrency } from '../components/SelectPaycycleCurrency';

export const CompanyPays = () => {
  return (
    <>
      <SectionHeading
        title="What your company pays 🏦"
        actionComponents={[<SelectPaycycleCurrency key="SelectPaycycleCurrency" />]}
      />

      <CompanyPaysTable />
    </>
  );
};
